/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import type Record from './Record';

export default interface User extends Record {
  accountType?: string; // Analytics Data Layer: The account level of the user for your given product.
  attributes?: any; // Analytics Data Layer: additional values stored in key:value pairs with the value ALWAYS being strings.
  authId?: string; // user's authentication id used for type2e (IMS) identification
  authOrigin?: string; // Analytics Data Layer: The origin of where the user logged in or "anonymous" if the user is not logged in.
  authSystem?: string; // Analytics Data Layer: The system used to provide the user.id and user.corpId.
  displayName?: string; // firstname lastname - for convenience in viewing/searching
  groupId?: string; // user's group identifier, e.g. currently selected IMS org, or a solution user group
  groupName?: string; // current effective group for the user, e.g. current IMS org, for viewing/searching
  ipAddress?: string; // as viewed by the metrics gateway - an indicator of the user's location
  language?: string; // Analytics Data Layer: The language/locale setting the user has currently selected within the UI.
  privileges?: string[]; // Analytics Data Layer: Privileges that the user currently has access to as relating to the product as a whole.
  sessionId?: string; // user's session identifier, e.g. IMS session or browser session header/cookie
  userAgent?: string; // a client identifier, e.g. the User-Agent request header
  userId?: string; // user's login string, e.g. AdobeId or username, as submitted to the auth system
}

export const UserOptOutAllowList = [
  'attributes',
  'authSystem',
  'dateNow',
  'event',
  'metricsState',
  'recordType',
  'timestamp',
  'userHash',
];
